// extracted by mini-css-extract-plugin
module.exports = {"loading":"media-item-card_loading_2Gld7"};